export const PREVENT_SHOW_STATIC_TOOLTIP_STORAGE_KEY = 'preventShowStaticTooltipKeys'
export const ACTIVE_TOOLTIP_PARENT_REF = 'activeTooltipParentRef'
